import React, { useMemo, useState } from 'react'
import { ReactComponent as ArrowRight } from 'assets/icons/arrow_short_right.svg'
import EssayReviewSlideCard from 'shared/components/EssayReviewSlideCard/EssayReviewSlideCard'
import { buildEssaySlideCardProps } from 'shared/essayReview/essayReviewModel'
import { sortEssaysByPriority } from '../../../utils/essayStatusPriority'
import s from './Essays.module.scss'

const Essays = ({ row, onOpenEssay }) => {
	const sorted = useMemo(
		() => sortEssaysByPriority(row?.essays || []),
		[row?.essays],
	)

	const [index, setIndex] = useState(0)

	if (!sorted.length) {
		return (
			<section className={s.wrap}>
				<header className={s.header}>
					<h4 className={s.title}>Essays</h4>
					<span className={s.count}>0</span>
				</header>
				<p className={s.empty}>No essays yet</p>
			</section>
		)
	}

	const safeIndex = Math.min(index, sorted.length - 1)
	const active = sorted[safeIndex]
	const slideProps = buildEssaySlideCardProps(active)
	const hasMany = sorted.length > 1

	const prev = () => setIndex(i => (i - 1 + sorted.length) % sorted.length)
	const next = () => setIndex(i => (i + 1) % sorted.length)

	return (
		<section className={s.wrap}>
			<header className={s.header}>
				<h4 className={s.title}>Essays</h4>
				<span className={s.count}>{sorted.length}</span>
			</header>

			<div className={s.carousel}>
				{hasMany && (
					<button
						type="button"
						className={s.navBtn}
						onClick={prev}
						aria-label="Previous essay"
					>
						<ArrowRight />
					</button>
				)}

				<EssayReviewSlideCard
					{...slideProps}
					onOpen={() => onOpenEssay?.(active)}
				/>

				{hasMany && (
					<button
						type="button"
						className={s.navBtn}
						onClick={next}
						aria-label="Next essay"
					>
						<ArrowRight />
					</button>
				)}
			</div>
		</section>
	)
}

export default Essays
